<template>
    <v-card-actions>
        <v-spacer />
        <v-btn
            @click="save"
            color="green"
            text
        >
            Save
        </v-btn>
        <v-btn
            @click="close"
            color="red darken-1"
            text
        >
            Cancel
        </v-btn>
    </v-card-actions>
</template>

<script>
    export default {
        name: "EditDialogActions",

        props: {
            save: {
                default: undefined,
                type: Function
            },
            close: {
                default: undefined,
                type: Function
            }
        }
    }
</script>

<style scoped>

</style>
